/* eslint-disable func-names */
import * as Yup from 'yup'

export const CommentSchema = Yup.object().shape({
  review: Yup.string().required('Please enter a Customer Comment'),
  status: Yup.string(),
})
